export default [
  {
    path: "/papelera",
    component: () => import("@/views/papelera/Listar.vue"),
  },
];
